import { PartnersTypeaheadService } from './partners-typeahead-service'
import { PartnerService } from './partner.service'
import { PartnerAndLocationRoleEnum } from '../models/PartnerAndLocationRoleEnum'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class SubcontractorTypeaheadServiceService extends PartnersTypeaheadService {
  constructor(partnerService: PartnerService) {
    super(partnerService);
  }

  name(): string {
    return PartnerAndLocationRoleEnum.SUBCONTRACTOR;
  }
}
